import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form/immutable";
import { Card, CardHeader } from "material-ui/Card";
import { Flex, Box } from "rebass";
import { TextField } from "redux-form-material-ui";
import RaisedButton from "material-ui/RaisedButton";
import CircularProgress from "material-ui/CircularProgress";
import { cyan500 } from "material-ui/styles/colors";
import { red500 } from "material-ui/styles/colors";
import { RestApiTicketScan } from "../restClient";
import { CubeGrid } from "../components/spinkit";

const required = value => (value == null ? "Required" : undefined);
const valuemin = value =>
  value.trim() === "" ? "Can not be empty" : undefined;

class TicketInputForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: "",
      productId: props.detailProduct.id,
      color: "transparent",
      dataScan: {},
      message: "",
      ref: "",
      isRead: false,
      isLoading: false,
      selectVariant: props.selectVariant,
      selectSKU: props.selectSKU
    };
  }
  onSubmit = values => {
    const params = {
      product_id: this.state.productId,
      ref: values.ref,
      device_id: "web",
      variant: this.state.selectVariant,
      sku: this.state.selectSKU
    };
    this.setState({
      isLoading: true
    });
    this.fetchScan(params);
  };

  fetchScan = params => {
    //console.log(JSON.stringify(params));
    RestApiTicketScan(params)
      .then(response => {
        if (response.status >= 400) {
          this.setState({
            isLoading: false,
            data: "Invalid",
            color: red500,
            dataScan: {},
            isRead: true,
            message: "Bad Response"
          });
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(data => {
        if (data.message !== undefined) {
          this.setState({
            isLoading: false,
            data: "Invalid",
            color: red500,
            dataScan: {},
            message: data.message,
            isRead: true
          });
        } else {
          this.setState({
            isLoading: false,
            data: "Valid",
            color: cyan500,
            dataScan: data,
            message: "",
            isRead: true
          });
        }
      })
      .catch(e => {
        this.setState({
          isLoading: false
        });
        //console.error(e);
      });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.detailProduct && nextProps.selectVariant) {
      this.setState({
        productId: nextProps.detailProduct.id,
        selectVariant: nextProps.selectVariant,
        selectSKU: nextProps.selectSKU
      });
    }
  }

  renderInfo() {
    if (this.state.isLoading) {
      return (
        <div>
          <CubeGrid size={60} color={cyan500} />
        </div>
      );
    }
    return (
      <div>
        {this.state.isRead && (
          <Flex direction="row" p={[2]} align="center">
            {this.state.data === "Valid" ? (
              <span style={styles.iconStyles}>
                <i
                  className="material-icons"
                  style={{ fontSize: "50pt", color: this.state.color }}
                >
                  &#xE876;
                </i>
              </span>
            ) : (
              <span style={styles.iconStyles}>
                <i
                  className="material-icons"
                  style={{ fontSize: "50pt", color: this.state.color }}
                >
                  &#xE5CD;
                </i>
              </span>
            )}
            <Box>
              {" "}
              <span style={{ fontSize: "50pt", color: this.state.color }}>
                {" "}
                {this.state.data}{" "}
              </span>{" "}
            </Box>
          </Flex>
        )}
        {this.state.data === "Invalid" && (
          <BoxMessage>{this.state.message}</BoxMessage>
        )}
      </div>
    );
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    return (
      <div>
        <Card containerStyle={{ padding: 16, marginBottom: 16 }}>
          <CardHeader title="Check Ticket" />
          <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            <Box w={[1]}>
              <Field
                name="ref"
                component={TextField}
                hintText="ticket code"
                floatingLabelText="Ticket Reference Number"
                validate={[required, valuemin]}
              />
            </Box>
            <Box w={[1]} py={[2]}>
              <RaisedButton
                primary={true}
                label="Check"
                type="submit"
                icon={
                  this.state.isLoading ? (
                    <CircularProgress size={25} thickness={2} />
                  ) : (
                    <span />
                  )
                }
                disabled={submitting}
              />
            </Box>
          </form>
          {this.renderInfo()}
        </Card>
      </div>
    );
  }
}

const styles = {
  title: {
    fontSize: "2.750em",
    flexDirection: "row",
    display: "flex"
  },
  iconStyles: {
    margin: 6,
    textAlign: "center"
  }
};

const BoxMessage = Box.extend`
  color: ${red500};
`;

const formed = reduxForm({
  form: "scan-ticket-form"
})(TicketInputForm);

const mapStateToProps = state => {
  var initialValues = {
    ref: ""
  };

  return { initialValues, formState: state };
};

TicketInputForm.propTypes = {
  detailProduct: PropTypes.object,
  selectVariant: PropTypes.object,
  selectSKU: PropTypes.string
};

export default connect(mapStateToProps, {})(formed);

//export default TicketInputForm;



// WEBPACK FOOTER //
// ./src/tickets/TicketInputForm.js